import React from 'react'
import { observer } from 'mobx-react-lite'

import List from '@mui/material/List'

import AccountActions from './AccountActions'
import AccountConnection from './AccountConnection'
import AccountDetails from './AccountDetails'

import { ANALYTICS_EVENTS, useEvent } from '../../../../common'

const AccountDetailsTab = () => {
  const { onEvent } = useEvent()
  React.useEffect(() => onEvent(ANALYTICS_EVENTS.ACCOUNT_DETAILS_VIEW), [])

  return (
    <List>
      <AccountDetails />
      <AccountConnection />
      <AccountActions />
    </List>
  )
}

export default observer(AccountDetailsTab)
